// imports other JS-files to be bundled or prefetched

import { helpers } from './helpers';
import { icons } from './icons';
import { modals } from './modals';
import { sliderImages } from './slider-images';
import { product } from './product';
import { sentry } from './sentry';
import { EventEmitter } from 'events';

import AirDatepicker from 'air-datepicker';
import localeDa from 'air-datepicker/locale/da';
import localeDe from 'air-datepicker/locale/de';
import localeFi from 'air-datepicker/locale/fi';
import localeFr from 'air-datepicker/locale/fr';
import localeNl from 'air-datepicker/locale/nl';
import localeSv from 'air-datepicker/locale/sv';

// CACHE IMPORTED MODULES

import('./about')
import('./after-sales')
// import('./architect-bar')
import('./brands')
import('./campaign')
import('./checkout')
import('./company-services')
import('./best-in-test')
import('./dpj-faq')
import('./form-validation')
import('./home-office')
import('./homepage')
import('./inredningshjalpen');
import('./my-account')
import('./order-confirmation')
import('./order-tracking')
import('./product-list')
// import('./product') // Product page is a common first load page. Including it in main bundle. 
// import('./project-sales')
import('./special-event')
import('./store')
import('./classes/ProductSlider')
import('./classes/ScrollAnimatedVideo')
import('./footer')
import('./sentry')
// Error handling and logging   

export const app = {
    isSmallDevice: false,
    scrollTop: 0,
    buildTimestamp: null,
    commitHash: null,
    init: () => {
        console.debug("app.js: init");
        try {
            app.buildTimestamp = process.env.BUILD_TIMESTAMP;
            app.commitHash = process.env.COMMIT_HASH;
        } catch (error) {
            console.error('Error loading app', error);
        }
        console.log(`-----------------------\nhash:  ${app.commitHash}\ntime:  ${app.buildTimestamp}\nbuild: ${process.env.BUILD_ENV}\n-----------------------`);
        window.dataLayer = window.dataLayer || [];

        // attatch objects to the window for use in modules and other scripts
        const globals = {
            helpers: helpers,
            icons: icons,
            modals: modals,
            sentry: sentry,
            airdatepicker: {
                AirDatepicker: AirDatepicker,
                localeDa: localeDa,
                localeDe: localeDe,
                localeFi: localeFi,
                localeFr: localeFr,
                localeNl: localeNl,
                localeSv: localeSv,
            }
        }
        if (window.dpj) {
            window.dpj = {
                ...window.dpj,
                ...globals
            };
        } else {
            window.dpj = {
                ...globals
            };
        }

        // calls the EventEmitter constructor with prestashop as its "this".
        // sets the Objects prototype to the EventEmitter prototype.
        //
        // (love me some prototypical inheritance @johan-st)
        EventEmitter.call(prestashop);
        Object.setPrototypeOf(prestashop, EventEmitter.prototype);

        $(document).ready(() => {
            // -- PRESTASHOP --
            if (typeof prestashop !== 'undefined') {
                prestashop.setMaxListeners(30)
                prestashop.on('updatedCart', () => {
                    $.each(['.cart-overview', '.cart-detailed-totals'], (i, el) => {
                        $(el).closest('.checkout-overlay').remove();
                        $(el).fadeTo(200, 1);
                    });
                });
            }


            //  -- UNCONDITIONAL INITIALIZATION --
            app.isSmallDevice = helpers.isSmallDevice();
            modals.init();
            app.applyListeners();
            app.lazyLoadImages();
            app.showLocationContent();
            app.dpjHacksAndFixes();
            app.onFocusSearchField();
            app.setHeaderToFixedMode();
            //app.enableBlackWeek();
            helpers.pageHistory.set();
            helpers.accordionInit();
            icons.init();
            sliderImages.init();
            helpers.removePriceDecimals(`
                .product-cover .discount,
                #header-cart-wrapper .product-price,
                #header-cart-wrapper td:nth-of-type(2),
                .adtm_sub .product-list-item .price,
                .cart-overview .product-line-info.product-price .price,
                .cart-overview .product-line-info.product-price .regular-price,
                .cart-summary .cart-summary-line .value,
                .product-list-item .price,
                .product-list-item .regular-price
            `);

            //   -- CONDITIONAL INITIALIZATION --
            // dev only code
            if (process.env.NODE_ENV === 'development') {
                app.tryIf(true, async () => {
                    const { default: debug } = await import('./debug.js');
                    window.dpj.debug = debug;

                    // Robert's exit form trigger test
                    // let triggerCount = 0;
                    // const _cleanup = debug.ExitIntentAction(
                    //     () => {
                    //         alert("Vart ska'ru?! \n\nHär funtar vi på att ha en 'exit form' för att fånga upp när användaren lämnar sidan. \nTanken är att de ska få ett formulär att fylla i som vi kan lära oss vad som gör att de lämnar sidan. \n\n/johan-st")
                    //         triggerCount++;
                    //     },
                    //     () => {
                    //         triggerCount++;
                    //         if (triggerCount >= 5) {
                    //             debug.visualIndicator(`exit form triggered ${triggerCount} times, cleaning up!`, 'warning');
                    //             _cleanup();
                    //             return;
                    //         }
                    //         debug.visualIndicator(`exit form triggered ${triggerCount} times`)
                    //     });
                });
            }

            // modules
            // - CHECKOUT
            app.tryIf("#module-dpjcheckout-dpjcheckout",
                async () => {
                    sentry.init().then(() => {
                        sentry.breadcrumb({
                            category: "dpjcheckout",
                            message: "init",
                            level: "debug",
                        });
                        // sentry.replayStart(); // start and capture a replay
                        sentry.bufferReplay(); // buffer the replay. Needs to be flushed manually unless an error occurs.
                    });
                    import('./form-validation.rules').then(({ rules }) => {
                        window.dpj.formValidationRules = rules;
                    });
                    import('./form-validation').then(({ formValidation }) => {
                        window.dpj.formValidation = formValidation;
                    });

                });
            app.tryIf("#cart, #module-dpjcheckout-dpjcheckout",
                async () => {
                    const { checkout } = await import('./checkout');
                    checkout.init();
                });


            // -- OTHER --
            app.tryIf(".about__wrapper",
                async () => {
                    const { about } = await import('./about');
                    about.init();
                });
            app.tryIf(".fresh-form",
                async () => {
                    const { afterSales } = await import('./after-sales');
                    afterSales.init();
                });
            // app.tryIf("#architect-bar",
            //     async () => {
            //         const { architectBar } = await import('./architect-bar');
            //         architectBar.init();
            //     });
            app.tryIf(".brands-navigation__rune, .brands-listing__group",
                async () => {
                    const { brands } = await import('./brands');
                    brands.init();
                });
            app.tryIf(".campaign-side-banner-video, .campaign-wrapper",
                // TODO: is it used?
                async () => {
                    const { campaign } = await import('./campaign');
                    campaign.init();
                });
            app.tryIf(".best-in-test-wrapper",
                async () => {
                    const { bestInTest } = await import('./best-in-test');
                    bestInTest.init();
                });
            app.tryIf("#company-services-wrapper",
                // TODO: Better way to exclude this from being loaded on the inredningshjalpen page
                async () => {
                    const { companyServices } = await import('./company-services');
                    companyServices.init();
                });
            app.tryIf(".contact-form-item-chat",
                async () => {
                    const { dpjFaq } = await import('./dpj-faq');
                    dpjFaq.init();
                });
            app.tryIf(".home-office-wrapper",
                // TODO: is it used?
                async () => {
                    const { homeOffice } = await import('./home-office');
                    homeOffice.init();
                });
            app.tryIf("#homepage-wrapper, .slider-tabs-container",
                async () => {
                    const { homepage } = await import('./homepage');
                    homepage.init();
                });
            app.tryIf(".inredningshjalp-wrapper",
                async () => {
                    const { inredningshjalpen } = await import('./inredningshjalpen');
                    inredningshjalpen.init();
                });
            app.tryIf("#authentication",
                // TODO: is it used?
                async () => {
                    const { myAccount } = await import('./my-account');
                    myAccount.init();
                });
            app.tryIf("#order-confirmation",
                async () => {
                    const { orderConfirmation } = await import('./order-confirmation');
                    orderConfirmation.init();
                });
            app.tryIf(".TrackMyOrderMain",
                async () => {
                    const { orderTracking } = await import('./order-tracking');
                    orderTracking.init();
                });
            app.tryIf("#js-product-list, .product-slider, .recommended-products-list",
                async () => {
                    const { list } = await import('./product-list');
                    list.init();
                });
            app.tryIf("#product",
                async () => {
                    // Product page is a common first page. Including in main bundle.
                    // const { product } = await import('./product');
                    product.init();
                    window.dpj.product = product;
                });
            // app.tryIf(".project-sales-wrapper",
            //     async () => {
            //         const { projectSales } = await import('./project-sales');
            //         projectSales.init();
            //     });
            app.tryIf("#special-event",
                // TODO: is it used?
                async () => {
                    const { specialEvent } = await import('./special-event');
                    specialEvent.init();
                });
            app.tryIf(".store-wrapper",
                // TODO: is it used?
                async () => {
                    const { store } = await import('./store');
                    store.init();
                });

            // classes
            app.tryIf(".product-slider",
                // TODO: is it used?
                async () => {
                    const { ProductSlider } = await import('./classes/ProductSlider');
                    ProductSlider.initAuto();
                    window.dpj.ProductSlider = ProductSlider;
                });
            app.tryIf(".scroll-animated-video",
                // TODO: is it used?
                async () => {
                    const { ScrollAnimatedVideo } = await import('./classes/ScrollAnimatedVideo');
                    window.dpj.ScrollAnimatedVideo = ScrollAnimatedVideo;
                });
            app.tryIf("#signupnewsletteremail",
                async () => {
                    const { footer } = await import('./footer');
                    footer.init();
                });
        });
    },
    applyListeners: () => {
        // Function to apply general site listeners
        $(window).on('resize', () => {
            app.isSmallDevice = helpers.isSmallDevice();
        });
        $(window).on('scroll', helpers.throttle(app.setHeaderToFixedMode, 80));
        app.setHeaderToFixedMode();
        //$(window).bind('scroll.lazyScroll', app.lazyLoadImages);
        $(window).on('scroll', app.lazyLoadImages);
        $(window).bind('scroll.lazyResize', helpers.throttle(app.lazyLoadImages));
        document.addEventListener('updateListFilters', app.lazyLoadImages, false);
        $('.select-vat, .select-product-order, .select-country').change(modals.renderLoading);
        $('#header-cart-wrapper > a').click(e => {
            return helpers.isSmallDevice() && $('#header-cart-wrapper > .quantity').text() != '0' ? false : true;
        });
        $('img').on('error', app.adjustMissingImages);
        $('.headerlayout').on('click', '.toggle-search', app.openMobileSearch);
        $('.header-search-new').on('click', '.dpj-close-search', app.closeMobileSearch);
        $('#footer').on('click', '.footer-top-section > div', app.toggleFooterSection);
        $('.header-search').on('click', '.icon ', app.focusSearchField);
        app.validateHoneypot();
    },
    lazyLoadImages: () => {
        // Function to lazy load all images in various product lists
        if ($('.lazy-load').length) {
            $('.lazy-load').each((i, el) => {
                let img = $(el);
                if (img.offset().top < window.innerHeight + window.pageYOffset + 300) {
                    img.attr('src', img.attr('data-src')); // Should probably hange attr() to prop()
                    img.load(() => { img.removeClass('lazy-load'); });
                }
            });
            return;
        }
        $(window).unbind('.lazyScroll');
        $(window).unbind('.lazyResize');
        window.removeEventListener('scroll', app.lazyLoadImages);
        window.removeEventListener('resize', app.lazyLoadImages);
    },
    /**
     * @description Function to remove all images that are missing a valid source
     */
    adjustMissingImages: (e) => {
        const currentTarget = $(e.currentTarget);
        const ignoreClass = "dpj-ignoreAdjustMissingImages"
        if (currentTarget.hasClass(ignoreClass)) {
            return;
        }
        console.warn("Missing image src: " + e.currentTarget.src);
        currentTarget.remove();
    },
    setHeaderToFixedMode: () => {
        // Function to fix the header whenever the visitors scrolls the page below the actual default header
        const currentScroll = $(window).scrollTop();
        const body = $('body');
        if (currentScroll > 0) {
            body.addClass('fixed');
            //$("#main-header").addClass("header-fixed");
            $(".header-fill-space").css("display", "block");
        }
        else {
            body.removeClass('fixed');
            //$("#main-header").removeClass("header-fixed");
            $(".header-fill-space").css("display", "none");
        }
    },
    showLocationContent: function () {
        return;
        // Show information about the butik if the user is located in stockholm
        var t = $(".location-content");
        "https://www.dpj.se/" == prestashop.urls.base_url && t.length && $.ajax({
            dataType: "jsonp",
            data: "format=jsonp",
            url: "https://api.ipify.org",
            success: function (e) {
                var d = new Date();
                var day = d.getDate();
                var token = day % 2 == 0 ? '4aeca6aab8bf46' : '3e95c57b40d926'
                $.ajax({
                    dataType: "json",
                    //http://ip-api.com/json/24.48.0.1
                    url: "https://ipinfo.io/".concat(e.ip, "?token=", token),
                    success: function (e) {
                        -1 !== e.region.toLowerCase().indexOf("stockholm") && t.addClass("active")
                    }
                })
            }
        })
    },
    dpjHacksAndFixes: () => {
        // Special cases for German site
        if (prestashop.urls.base_url == 'https://www.dpj-workspace.com/de/') {
            // set z-index to allow privacy controll to obscure trustbadge.
            setTimeout(() => {
                $("#trustbadge-container-98e3dadd90eb493088abdc5597a70810").css("z-index", 99999);
            }, 5000);

            // Make sure that the brands link does not redirect the user from Germany to Austria
            $('a[href="/at/brands"]').attr("href", "/de/brands");
        }

        // Special cases for AT
        if (prestashop.urls.base_url == 'https://www.dpj-workspace.com/at/') {
            $('.footer-top-section a[href="https://www.dpj-workspace.com/de/faq"]').attr("target", "_self");
            $('.footer-top-section a[href="https://www.dpj-workspace.com/de/faq"]').attr("href", "https://www.dpj-workspace.com/at/faq");
        }

        // workaround for stripped away attributes on cms page
        if (document.getElementById("cms") != undefined) {
            const mutedEls = document.getElementsByClassName("video--muted");
            for (let i = 0; i < mutedEls.length; i++) {
                mutedEls[i].setAttribute("muted", "");
                mutedEls[i].muted = true;
            }
            const loopEls = document.getElementsByClassName("video--loop");
            for (let i = 0; i < loopEls.length; i++) {
                loopEls[i].setAttribute("loop", "")
            }
            const autoplayEls = document.getElementsByClassName("video--autoplay");
            for (let i = 0; i < autoplayEls.length; i++) {
                autoplayEls[i].setAttribute("autoplay", "")
            }
            const playsinlineEls = document.getElementsByClassName("video--playsinline");
            for (let i = 0; i < playsinlineEls.length; i++) {
                playsinlineEls[i].setAttribute("playsinline", "")
            }
            const formRequiredInputs = document.getElementsByClassName("form__input--required");
            for (let i = 0; i < formRequiredInputs.length; i++) {
                formRequiredInputs[i].setAttribute("required", "")
            }
            const formEmailInputs = document.getElementsByClassName("form__input--email");
            for (let i = 0; i < formEmailInputs.length; i++) {
                formEmailInputs[i].setAttribute("type", "email")
            }
            const formDateInputs = document.getElementsByClassName("form__input--date");
            for (let i = 0; i < formDateInputs.length; i++) {
                formDateInputs[i].setAttribute("type", "date")
            }
            const formMultipleInputs = document.getElementsByClassName("form__input--multiple");
            for (let i = 0; i < formMultipleInputs.length; i++) {
                formMultipleInputs[i].setAttribute("multiple", "")
            }

        }

        // If the user clicks the magnifying glass on desktop it should bring up the search window
        // Sorry for ugly timeout but we need to wait for icons.js to replace the div to svg
        setTimeout(() => {
            $(".header-search .dpj-icon-search").css("cursor", "pointer");
            $(".header-search .dpj-icon-search").click(function () {
                $(".aw-search-input").focus();
            });
        }, 1500);

        // conditionaly show element based on if the user is a consumer or business
        var isConsumer = prestashop.configuration.display_prices_tax_incl;
        var consumerEls = $(".display-if-consumer");
        var businessEls = $(".display-if-business");

        if (isConsumer) {
            businessEls.hide();
            consumerEls.show();
        }
        else {
            businessEls.show();
            consumerEls.hide();
        }

    },
    focusSearchField: () => {
        if (!app.isSmallDevice) {
            $(".header-search input").focus();
        }
    },
    onFocusSearchField: () => {
        setTimeout(function () {
            if (!app.isSmallDevice) {
                // make sure header is highlighted during search
                $(".header-search .input-search").on("keydown", function () {
                    $(".header-search .input-search").css("position", "relative");
                    $(".header-search .input-search").css("z-index", "101");
                });
            }
        }, 2000);
    },
    closeMobileSearch: () => {
        $(".header-search").fadeOut();
        $(".input-search .aw-search-form input").val("");
        $(".header-logo").css("display", "block");
        $(".dpj-close-search").css("display", "none");
    },
    openMobileSearch: () => {
        if (app.isSmallDevice) {
            $(".header-search").fadeIn(400, () => {
                setTimeout(() => {
                    $('.header-search input').focus();
                    $('.header-search input').select();
                }, 200);
            });

            $(".header-logo").css("display", "none");

            // Close mobile main menu if open
            if ($(".header-mobile-menu .dpj-icon-close").css("display") != "none") {
                $(".header-mobile-menu .dpj-icon-close").trigger("click");
            }
            $(".dpj-close-search").css("display", "inline-block");

            // If user changes to desktop window resolution after opening mobile menu we need to reset the view to show searchbar & logo
            // this event could be attached several times but should be fine. A user would not open and closed the mobile menu significant amount of time in a single page visit
            $(window).on('resize', app.resetMobileSearch);
        }
    },
    resetMobileSearch: () => {
        if (!app.isSmallDevice) {
            $(".header-search").fadeIn();
            $(".header-logo").css("display", "block");
            $(".dpj-close-search").css("display", "none");
        }
    },
    toggleFooterSection: (e) => {
        if (app.isSmallDevice && e.target.tagName.toLowerCase() !== "a") {
            $(e.currentTarget).toggleClass("active");
        }
    },
    enableBlackWeek: () => {
        $("body").addClass("black-week");
        $(".home-campaign-large .home-button").prop("href", "/464-cyber-week");
        $(".home-campaign-large .input-button").html("Till våra superdeals");
    },

    validateHoneypot: () => {
        document.addEventListener('submit', function (event) {
            const form = event.target;
            const honeyPots = form.querySelectorAll('input.form-helper');
 
            const honeyPotFilled = [...honeyPots].some(input => input.value !== '');
 
            if (honeyPotFilled) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
            }
        }, true);
    },

    // ------------------------ UTILS ------------------------

    /**
     * @description Conditional block of code in a try catch block
     * @param {string|boolean} select - The selector to check (true = run always, false = run never, string = run if selector is found)
     * @param {Function} fn - A function that will be called if the code should be run
     * @returns {void}
     */
    tryIf: (select, fn) => {
        if (typeof select !== "string" && typeof select !== "boolean") {
            throw new Error("select must be a string or boolean");
        }

        if ((typeof select === "string" && !document.querySelector(select)) || (typeof select === "boolean" && !select)) {
            return;
        }

        try {
            fn();
        }
        catch (error) {
            console.error(`Error in fn for '${select}'`, error);
        }
    },
    // sentryInit: (release) => {
    //     const dsn = "https://61c5e0952eb3384cbfc4800a154dddbf@o4507526370623488.ingest.de.sentry.io/4507526376587344";


    //     // 1.0 = 100%, 0.1 = 10%, 0.01 = 1%
    //     let sampleRate = 0.05; // errors
    //     let tracesSampleRate = 0.1; // performance
    //     let replaysSessionSampleRate = 0.01; // session replay
    //     let replaysOnErrorSampleRate = 0.1; // session replay on error
    //     let runtime = "production";
    //     // let ignoreErrors = [];
    //     if (typeof dpj_runtime === "string") {
    //         runtime = dpj_runtime;
    //         if (runtime === "development") {
    //             sampleRate = 1.0;
    //             tracesSampleRate = 1.0;
    //             replaysSessionSampleRate = 0;
    //             replaysOnErrorSampleRate = 1.0;
    //             // ignoreErrors = [];
    //         }
    //     }

    //     Sentry.init({
    //         dsn,
    //         environment: runtime,
    //         release,
    //         maxBreadcrumbs: 30,
    //         integrations: [
    //             // Sentry.httpClientIntegration(), // events for failed xhr requests
    //             Sentry.browserTracingIntegration(), // optional, but required for performance monitoring
    //             // Sentry.replayIntegration(), // optional, but required  session replay
    //         ],
    //         // Error Capturing
    //         sampleRate,
    //         // ignoreErrors,

    //         // Performance Monitoring
    //         tracesSampleRate,

    //         // Session Replay
    //         replaysSessionSampleRate,
    //         replaysOnErrorSampleRate,
    //     });
    // }

}